import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

export const setFeaturedMedia = wrapWithNetworkError(function(
  token: string,
  {
    ugcId,
    featured,
  }: {
    ugcId: UgcId,
    featured: boolean,
  }
) {
  const fetchUrl = getEndpointUrl(
    `/moderate/content/ugc/${ugcId}/media?featured=${featured}`
  );
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(checkResponse)
    .then(response => response.json());
});



// WEBPACK FOOTER //
// ./src/containers/client/UgcFeaturedMediaApi.js